import { useParams } from 'react-router';

import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { MOBILE_APP_LINK_PATTERNS } from 'constants/mobileApplication';

interface IParams {
  guestPortalId?: string;
}
const useProposalPathForMobileAppBuilder = (proposalId: string | number, proposalType: string) => {
  const params: IParams = useParams();

  if (proposalType === ITINERARIES_ITEM_TYPES.GUEST_PORTAL && params.guestPortalId) {
    return `${MOBILE_APP_LINK_PATTERNS[proposalType]}/${params.guestPortalId}`;
  }

  return `${MOBILE_APP_LINK_PATTERNS[proposalType]}/${proposalId}`;
};

export default useProposalPathForMobileAppBuilder;
